<template>
  <v-row>
    <v-col class="px-0">
      <ul>
        <router-link tag="li" to="/tiers">Tiers</router-link>
        <router-link tag="li" to="/licences">Licensees</router-link>
        <router-link tag="li" to="/license-manager"
          >License Managers</router-link
        >
        <router-link tag="li" to="/businessfunction"
          >Business Function</router-link
        >
        <router-link tag="li" to="/designations">Designations</router-link>
        <router-link tag="li" to="/departments">Departments</router-link>
        <router-link tag="li" to="/ValueStreamMetrics">Value Stream Metrics</router-link>
        <router-link tag="li" to="/Analytics">Analytics</router-link>
        <router-link tag="li" to="/Marketing">Marketing</router-link>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({}),
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/colors.scss';
.side_nav {
  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 16px 40px;
      cursor: pointer;
      font-size: 14px;
      color: $primary-color-1;
      font-weight: 600;
      line-height: 22px;

      &.router-link-active,
      &:hover {
        background: rgba($primary-color-1, 0.05);
      }
    }
  }
}
</style>
